import { useEffect, useState, useRef } from 'react';
import dayjs from 'dayjs';
import { getPricingData } from '../utils/chartAPI';

export default function usePricingData({
  site,
  msSessionInfo,
  startDate,
  endDate,
  inView,
  refreshKey,
}) {
  const [loading, setLoading] = useState(true);
  const [series, setSeries] = useState([]);
  const hasFetched = useRef(false);

  useEffect(() => {
    hasFetched.current = false;
  }, [refreshKey, startDate?.valueOf?.(), endDate?.valueOf?.()]);

  useEffect(() => {
    if (!inView || !site?.id || !msSessionInfo) return;
    if (!startDate || !endDate) {
      setLoading(false);
      setSeries([]);
      return;
    }
    if (refreshKey === undefined && hasFetched.current) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const start = dayjs(startDate);
        let end = dayjs(endDate);
        if (!end.isAfter(start)) end = start.add(1, 'minute');

        const raw = await getPricingData(msSessionInfo, site, start, end);

        const pts = (raw?.prices ?? []).map(p => ({
          x: dayjs(p.time).valueOf(),
          y: Number(p.price),
        }));

        setSeries([{ name: 'Price', type: 'column', data: pts }]);
        hasFetched.current = true;
      } catch (err) {
        console.error('Pricing fetch error:', err);
        setSeries([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    inView,
    site?.id,
    msSessionInfo,
    startDate?.valueOf?.(),
    endDate?.valueOf?.(),
    refreshKey,
  ]);

  return { loading, series };
}
